import * as React from "react";
import moment from "moment";
import styled from "../../lib/styled";
import { Link } from "gatsby";
import { presets } from "../../lib/presets";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

interface InfoBannerProps {
  icon: FontAwesomeIconProps["icon"];
  iconSet: "fas" | "fab";
  text: string;
  bannerType?: string;
  bannerTitle?: string;
}

const InfoBanner: React.FC<InfoBannerProps> = (props) => {
  return (
    <Wrapper className={`info-banner--wrapper ${props.bannerType}`}>
      <div className="info-banner--banner-header">
        <div className="info-banner--left">
          {/* 
        // @ts-ignore */}
          <FontAwesomeIcon icon={[props.iconSet, props.icon]} />
        </div>
        <div className="info-banner--right">
          <p className="info-banner--banner-title">{props.bannerTitle}</p>
        </div>
      </div>
      <div className="info-banner--banner-content">
        <p className="info-banner--text">{props.text}</p>
      </div>
    </Wrapper>
  );
};

export default InfoBanner;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  padding: 10px 5px;

  &.warning {
    background-color: #ff9f05;
  }

  &.notice {
    background-color: #92bef0;
  }

  &.good {
    background-color: #7fd421;
  }

  &.bad {
    background-color: #f85454;
  }

  &.urgent {
    background-color: white;
    border: 2px solid black;
  }

  .info-banner--icon {
    font-size: 1.5rem;
    color: #000;
  }

  .info-banner--banner-header {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .info-banner--icon {
    font-size: 1.5rem;
    color: black;
  }

  .info-banner--left {
    padding: 10px 15px;
  }

  .info-banner--banner-title {
    font-family: "Bebas Neue", "Helvetica", "Arial", sans-serif;
    font-size: 18px;
    color: black;
    line-height: 1em;
    margin: 0;
  }

  .info-banner--text {
    color: black;
    line-height: 1em;
    margin: 0;
  }

  .info-banner--banner-content {
    padding: 5px 15px 10px 15px;
  }
`;
